import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
} from "@/components/help/help-ui";

const please = () => [
  i18n.t("help.guidelines.pleaseItems.kind"),
  i18n.t("help.guidelines.pleaseItems.honest"),
  i18n.t("help.guidelines.pleaseItems.boundaries"),
  i18n.t("help.guidelines.pleaseItems.noResponse"),
  i18n.t("help.guidelines.pleaseItems.appropriate"),
  i18n.t("help.guidelines.pleaseItems.public"),
  i18n.t("help.guidelines.pleaseItems.report"),
];

/**
 * The two things that are not a matter of degree.
 *
 * Its own section rather than two more bullets under "Not allowed", and placed
 * BEFORE it. Everything in that list is a judgement about how far somebody
 * went; these are lines with no far side, and burying them among six ordinary
 * prohibitions would say the opposite. The Terms already commit to both — 18+
 * only, and no unlawful use — so this is the plain-language half of a promise
 * that already exists, not a new rule.
 */
const never = () => [
  i18n.t("help.guidelines.neverItems.underage"),
  i18n.t("help.guidelines.neverItems.minors"),
  i18n.t("help.guidelines.neverItems.illegal"),
];

const notAllowed = () => [
  i18n.t("help.guidelines.notAllowedItems.harassment"),
  i18n.t("help.guidelines.notAllowedItems.sexual"),
  i18n.t("help.guidelines.notAllowedItems.spam"),
  i18n.t("help.guidelines.notAllowedItems.impersonation"),
  i18n.t("help.guidelines.notAllowedItems.private"),
  i18n.t("help.guidelines.notAllowedItems.contact"),
];

export default function CommunityGuidelines() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.guidelines.title")}>
      <HelpIntro>{i18n.t("help.guidelines.intro")}</HelpIntro>

      <HelpSection
        heading={i18n.t("help.guidelines.please")}
        bullets={please()}
      />

      <HelpSection
        heading={i18n.t("help.guidelines.never")}
        bullets={never()}
      />

      {/*
        Its own consequence, because it is a different one. "Can lead to
        suspension or account removal" is true of everything above and would
        read as a de-escalation here.
      */}
      <HelpSection body={i18n.t("help.guidelines.neverConsequence")} />

      <HelpSection
        heading={i18n.t("help.guidelines.notAllowed")}
        bullets={notAllowed()}
      />

      <HelpSection body={i18n.t("help.guidelines.consequence")} />

      <HelpButton
        label={i18n.t("help.guidelines.report")}
        icon="flag-outline"
        variant="danger"
        onPress={() => router.push("/help/contact?source=safety")}
      />
    </HelpScreen>
  );
}
